import React from 'react';

/**
 * Phase 5.0B FINAL — Main match bottom HUD.
 *
 * Uses `hud_bottom_shell.svg` as the frame (background-image) with
 * real DOM content on top. LEFT = current turn label + optional
 * helper; RIGHT = DISCARD count + EXIT. All handlers/values come
 * from the caller — no new state.
 */
export default function MatchStatusBar({
  turnLabel,
  turnMuted = false,
  helperText,
  discardCount,
  onExit,
  turnTestId = 'turn-indicator',
  discardTestId,
  exitTestId,
  showExit = true,
}) {
  return (
    <div
      className="kk-match-bottom"
      role="status"
      style={{ backgroundImage: 'url(/gameplay/hud_bottom_shell.svg)' }}
    >
      <div className="min-w-0">
        <div
          data-testid={turnTestId}
          className={'kk-match-bottom__label' + (turnMuted ? ' kk-match-bottom__label--muted' : '')}
        >
          {turnLabel}
        </div>
        {helperText && (
          <div className="kk-match-bottom__helper">{helperText}</div>
        )}
      </div>
      <div className="kk-match-bottom__discard" data-testid={discardTestId || undefined}>
        DISCARD
        <b>{discardCount ?? 0}</b>
      </div>
      {showExit && onExit && (
        <button
          type="button"
          className="kk-match-bottom__exit"
          data-testid={exitTestId || undefined}
          onClick={onExit}
        >
          EXIT
        </button>
      )}
    </div>
  );
}
